import React, { useEffect, useState, useContext } from 'react';
import { useAdminAuth, API } from '../AdminAuthContext';
import CmsContext from '../../context/CmsContext';

import HeroEditor from '../editors/HeroEditor';
import DesafiosEditor from '../editors/DesafiosEditor';
import TransformacaoEditor from '../editors/TransformacaoEditor';
import ModulosEditor from '../editors/ModulosEditor';
import ResultadosEditor from '../editors/ResultadosEditor';
import PlanosEditor from '../editors/PlanosEditor';
import CasosSucessoEditor from '../editors/CasosSucessoEditor';
import TestimonialsEditor from '../editors/TestimonialsEditor';
import FooterEditor from '../editors/FooterEditor';
import PlataformaEditor from '../editors/PlataformaEditor';

const SECTIONS = [
  { key: 'hero', label: 'Hero', Editor: HeroEditor, group: 'Landing' },
  { key: 'desafios', label: 'Desafios', Editor: DesafiosEditor, group: 'Landing' },
  { key: 'transformacao', label: 'Transformação', Editor: TransformacaoEditor, group: 'Landing' },
  { key: 'modulos', label: 'Módulos', Editor: ModulosEditor, group: 'Landing' },
  { key: 'resultados', label: 'Resultados', Editor: ResultadosEditor, group: 'Landing' },
  { key: 'planos', label: 'Planos', Editor: PlanosEditor, group: 'Landing' },
  { key: 'casos_sucesso', label: 'Casos de Sucesso', Editor: CasosSucessoEditor, group: 'Landing' },
  { key: 'testimonials', label: 'Depoimentos', Editor: TestimonialsEditor, group: 'Landing' },
  { key: 'footer', label: 'Rodapé', Editor: FooterEditor, group: 'Landing' },
  { key: 'plataforma', label: 'Página Plataforma', Editor: PlataformaEditor, group: 'Páginas' },
];

const CmsPage = () => {
  const { authFetch } = useAdminAuth();
  const { refresh: refreshCms } = useContext(CmsContext);
  const [activeKey, setActiveKey] = useState('hero');
  const [data, setData] = useState(null);
  const [loading, setLoading] = useState(false);
  const [saving, setSaving] = useState(false);
  const [error, setError] = useState('');
  const [success, setSuccess] = useState('');

  const activeSection = SECTIONS.find(s => s.key === activeKey);

  useEffect(() => {
    setLoading(true);
    setError('');
    setSuccess('');
    setData(null);
    fetch(`${API}/api/cms/${activeKey}`)
      .then(r => r.json())
      .then(setData)
      .catch(() => setError('Erro ao carregar seção.'))
      .finally(() => setLoading(false));
  }, [activeKey]);

  const handleSave = async () => {
    setError('');
    setSuccess('');
    setSaving(true);
    try {
      const res = await authFetch(`/api/cms/${activeKey}`, {
        method: 'PUT',
        body: JSON.stringify(data),
      });
      if (!res.ok) throw new Error('Erro ao salvar.');
      setSuccess('Salvo! As mudanças aparecem no site imediatamente.');
      refreshCms();
    } catch (err) {
      setError(err.message);
    } finally {
      setSaving(false);
    }
  };

  const { Editor } = activeSection;

  return (
    <div className="flex gap-6 min-h-0">
      {/* Sidebar */}
      <div className="w-48 flex-shrink-0">
        <h2 className="text-base font-bold text-gray-900 mb-3">Seções</h2>
        <nav className="space-y-4">
          {['Landing', 'Páginas'].map(group => (
            <div key={group}>
              <p className="text-xs font-bold text-gray-400 uppercase tracking-widest mb-1 px-1">{group}</p>
              <div className="space-y-0.5">
                {SECTIONS.filter(s => s.group === group).map(({ key, label }) => (
                  <button
                    key={key}
                    onClick={() => setActiveKey(key)}
                    className={`w-full text-left px-3 py-2 rounded-xl text-sm font-medium transition-colors ${
                      activeKey === key ? 'bg-blue-600 text-white' : 'text-gray-600 hover:bg-gray-100'
                    }`}
                  >
                    {label}
                  </button>
                ))}
              </div>
            </div>
          ))}
        </nav>
      </div>

      {/* Editor area */}
      <div className="flex-1 min-w-0">
        <div className="flex items-center justify-between mb-4">
          <h2 className="text-base font-bold text-gray-900">
            Editando: <span className="text-blue-600">{activeSection.label}</span>
          </h2>
          <button
            onClick={handleSave}
            disabled={saving || loading || !data}
            className="bg-blue-600 text-white text-sm font-semibold px-5 py-2 rounded-xl hover:bg-blue-700 transition-colors disabled:opacity-60 flex items-center gap-2"
          >
            <span className="material-icons text-base">{saving ? 'hourglass_empty' : 'save'}</span>
            {saving ? 'Salvando...' : 'Salvar alterações'}
          </button>
        </div>

        {error && <p className="text-sm text-red-600 bg-red-50 rounded-xl px-4 py-3 mb-4">{error}</p>}
        {success && <p className="text-sm text-emerald-700 bg-emerald-50 rounded-xl px-4 py-3 mb-4">{success}</p>}

        <div className="bg-white rounded-2xl border border-gray-100 shadow-sm p-6 overflow-y-auto max-h-[calc(100vh-200px)]">
          {loading && (
            <div className="flex items-center justify-center py-16 text-gray-400">
              <span className="material-icons animate-spin mr-2">refresh</span>
              Carregando...
            </div>
          )}
          {!loading && data && (
            <Editor data={data} onChange={setData} />
          )}
        </div>
      </div>
    </div>
  );
};

export default CmsPage;
